export default {
  activityTemplates: [],
  templateBundles: [],
  templatesLoading: false
}
